(ns shared.core.components.button
  (:require ["semantic-ui-react" :as semantic-ui]
            [shared.core.components.interactive :refer [interactive]]
            [shared.core.style :as style]
            [shared.core.components.dropdown :as dd]
            [shared.core.loading :as loading]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]))

;; https://react.semantic-ui.com/elements/button/

(style/add-css [".ui.button" {:margin "0"}]
               [".ui.buttons .ui.novo-dropdown.dropdown>.dropdown.icon:before" {:color (style/color :white :base)}]
               [".ui.buttons .ui.novo-dropdown.dropdown>.text" {:display :none}]
               [".ui.buttons .ui.novo-dropdown.dropdown>div[id^=tippy-]" {:display :none}]
               [".ui.buttons>div>.ui.novo-dropdown.dropdown:last-child .menu" {:border (str "1px solid "
                                                                                            (style/color :gray :shade-1))}]
               [".ui.button" {:margin 0}]

               ;; dark-theme
               [".ui.buttons .ui.novo-dropdown.dark.dropdown>.dropdown.icon:before" {:color (style/dark-color :on-primary :base)}])

(def size-styles {:small {:border-radius 2
                          :font-size 12
                          :padding "0 8px"
                          :height 25}
                  :medium {:border-radius 3
                           :font-size 14
                           :padding "0 12px"
                           :height 32}
                  :large {:border-radius 4
                          :font-size 16
                          :padding "0 14px"
                          :height 40}})

(defn semantic-button [args & contents]
  (into [:> semantic-ui/Button args]
        contents))

(defn button-base [{:keys [loading-sub pre-loading-content post-loading-content]} & contents]
  (let [loading?- (and loading-sub (re/subscribe loading-sub))]
    (fn [{:keys [loading? size disabled?] :as args}]
      (let [size (or size :medium)
            loading? (or loading? (and loading?- @loading?-))
            args (cond-> args
                         disabled? (dissoc :on-click :hover-style :pressed-style)
                         loading? (dissoc :on-click :pressed-style))
            style (merge {:border-style :solid
                          :border-width 1
                          :cursor :pointer
                          :font-family style/font-family
                          :font-weight style/font-bold-weight
                          :display :flex
                          :align-items :center
                          :justify-content :center
                          :outline :none
                          :transition "0.2s"}
                         (when (or disabled? loading?)
                           {:cursor :not-allowed
                            :opacity 0.5})
                         (get size-styles size)
                         (:style args))]
        (into [interactive semantic-button (-> args
                                               (assoc :style style)
                                               (dissoc :loading? :loading-sub :disabled? :pre-loading-content
                                                       :post-loading-content))]
              (if loading?
                (concat pre-loading-content
                        [[loading/spinner {:color (or (:color style) (style/color :white :base))}]]
                        post-loading-content)
                contents))))))

(defn white-button [{:keys [style hover-style] :as args} & contents]
  (into [button-base (assoc args :style (merge {:background-color (style/color :white :base)
                                                :border-color (style/color :gray :shade-1)
                                                :color (style/color :gray :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :gray :shade-2)}
                                                     hover-style))]
        contents))

(defn white-on-background-button [{:keys [style hover-style] :as args} & contents]
  (into [button-base (assoc args :style (merge {:background-color (style/color :white :base)
                                                :border-color (style/color :on-background :base)
                                                :color (style/color :on-background :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :gray :shade-7)}
                                                     hover-style))]
        contents))

(defn white-borderless-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :white :base)
                                                :border-color :transparent
                                                :color (style/color :gray :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :gray :shade-2)}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :background :base)
                                                   :color (style/dark-color :on-background :base)}
                                           :hover-style {:background-color (style/dark-color :background :lighter-1)}}))]
        contents))

(defn red-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :red :base)
                                                :border-color (style/color :red :shade-1)
                                                :color (style/color :white :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :red :shade-2)}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :secondary :base)
                                                   :border-color (style/dark-color :secondary :darker-1)
                                                   :color (style/dark-color :on-secondary :base)}
                                           :hover-style {:background-color (style/dark-color :secondary :base)
                                                         :filter "brightness(1.3)"}}))]
        contents))

(defn red-outline-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :white :base)
                                                :border-color (style/color :red :base)
                                                :color (style/color :red :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :red :base)
                                                      :color (style/color :white :base)}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :on-secondary :base)
                                                   :border-color (style/dark-color :secondary :base)
                                                   :color (style/dark-color :secondary :base)}
                                           :hover-style {:background-color (style/dark-color :secondary :base)
                                                         :color (style/dark-color :on-secondary :base)}}))]
        contents))

(defn error-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :red :error)
                                                :border-color (style/color :red :error)
                                                :color (style/color :white :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :red :error)
                                                      :filter "brightness(1.3)"}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :secondary :base)
                                                   :border-color (style/dark-color :secondary :darker-1)
                                                   :color (style/dark-color :on-secondary :base)}
                                           :hover-style {:background-color (style/dark-color :secondary :base)
                                                         :filter "brightness(1.3)"}}))]
        contents))

(defn green-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :green :base)
                                                :border-color (style/color :green :shade-1)
                                                :color (style/color :white :base)}
                                               style)
                                 :hover-style (merge {:background-color (style/color :green :shade-2)}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :primary :base)
                                                   :border-color (style/dark-color :primary :darker-1)
                                                   :color (style/dark-color :on-primary :base)}
                                           :hover-style {:background-color (style/dark-color :primary :base)
                                                         :filter "brightness(1.3)"}}))]
        contents))

(defn green-button-group [{:keys [group-args button-args options]} & contents]
  (let [border (str "1px solid " (style/color :green :shade-1))
        dark-border (str "1px solid " (style/dark-color :primary :base))
        size-styles (get size-styles (or (:size button-args) :medium))
        border-radius (:border-radius size-styles)
        button-style {:border-radius (str border-radius "px 0 0 " border-radius "px")}]
    [:> semantic-ui/Button.Group group-args
     (into [green-button (assoc button-args :style (merge button-style (:style button-args))
                                            :on-click #(some-> (.. % -target -nextSibling)
                                                               (.querySelector ".dropdown")
                                                               (.click)))]
           contents)
     [theme/theme
      dd/dropdown {:class-name "button icon"
                   :options options
                   :on-change (fn [_ d]
                                (when-let [on-click (some->> options
                                                             (filter #(= (:value %) (aget d "value")))
                                                             (first)
                                                             :on-click)]
                                  (on-click)))
                   :disabled? (:disabled? button-args)
                   :value -1
                   :style {:background-color (style/color :green :base)
                           :border-radius (str "0 " border-radius "px " border-radius "px 0")
                           :border-top border
                           :border-right border
                           :border-bottom border
                           :display :flex
                           :align-items :center
                           :justify-content :center
                           :padding "0 8px"
                           :height (:height size-styles)}
                   :theme (style/dark-style {:background-color (style/dark-color :primary :base)
                                             :border-top dark-border
                                             :border-right dark-border
                                             :border-bottom dark-border})
                   :floating? true}]]))

(defn blue-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :blue :shade-1)
                                                :border-color (style/color :blue :shade-1)
                                                :color (style/color :white :base)}
                                               style)
                            :hover-style (merge {:background-color (style/color :blue :shade-2)}
                                                hover-style)
                            :theme (style/dark-prop
                                    {:style {:background-color (style/dark-color :primary :base)
                                             :border-color (style/dark-color :primary :darker-1)
                                             :color (style/dark-color :on-primary :base)}
                                     :hover-style {:background-color (style/dark-color :primary :base)
                                                   :filter "brightness(1.3)"}}))]
        contents))

(defn primary-button [{:keys [style hover-style] :as args} & contents]
  (into [theme/theme
         button-base (assoc args :style (merge {:background-color (style/color :primary :base)
                                                :border-color (style/color :primary :base)
                                                :color (style/color :on-primary :base)
                                                :font-family style/dm-sans-font-family
                                                :font-weight style/font-medium-weight}
                                               style)
                                 :hover-style (merge {:background-color (style/color :primary :base)
                                                      :filter "brightness(1.3)"}
                                                     hover-style)
                                 :theme (style/dark-prop
                                          {:style {:background-color (style/dark-color :primary :base)
                                                   :border-color (style/dark-color :primary :darker-1)
                                                   :color (style/dark-color :on-primary :base)}
                                           :hover-style {:background-color (style/dark-color :primary :base)
                                                         :filter "brightness(1.3)"}}))]
        contents))
